export default "__VITE_ASSET__DLvJMU2q__"